import { useContext } from "react";

import { type ConfirmDialogApi, ConfirmDialogContext } from "./confirm-dialog-context";

export function useConfirmDialog(): ConfirmDialogApi {
  const confirmDialogApi = useContext(ConfirmDialogContext);

  if (confirmDialogApi === null) {
    throw new Error("useConfirmDialog must be used inside ConfirmDialogProvider.");
  }

  return confirmDialogApi;
}
